// Weather API Configuration - Vedur.is via our proxy (to avoid CORS)
export const WEATHER_CONFIG = {
  stationId: 1, // Reykjavik
  city: 'Reykjavik',
  country: 'Iceland',
};

export const WEATHER_API = {
  // Use our own API proxy to avoid CORS issues with xmlweather.vedur.is
  baseUrl: '/api/weather',
  params: {
    station: WEATHER_CONFIG.stationId,
  },
};

// Currency API Configuration
// Using exchangerate-api.com for current rates - Free tier, no API key required
export const CURRENCY_API = {
  baseUrl: 'https://api.exchangerate-api.com/v4/latest',
  // The API endpoint is: /v4/latest/{currency_code}
  // So we construct the full URL with the base currency
};

// Historical Currency API Configuration
// Using frankfurter.dev (powered by European Central Bank data)
// Free tier, no API key required, no rate limits
export const HISTORICAL_CURRENCY_API = {
  baseUrl: 'https://api.frankfurter.dev/v1',
  // Endpoint format: /v1/{startDate}..{endDate}?base={currency}&symbols={targetCurrency}
  // Example: /v1/2025-10-21..2025-11-20?base=USD&symbols=ISK
};

// Air Quality API Configuration (Iceland Environment Agency - UST)
export const AIR_QUALITY_API = {
  baseUrl: 'https://api.ust.is/aq/a/getLatest',
  stationId: 'STA-IS0061A',
  stationName: 'Reykjavik Laugarnes',
};

// Holidays API Configuration (Nager.Date)
export const HOLIDAYS_API = {
  baseUrl: 'https://date.nager.at/api/v3/publicholidays',
  countryCode: 'IS',
};

// Vedur.is weather description to condition mapping
export const VEDUR_WEATHER_MAP: Record<string, string> = {
  'Clear sky': 'sunny',
  'Mostly clear': 'sunny',
  'Partly cloudy': 'partly-cloudy',
  'Cloudy': 'cloudy',
  'Overcast': 'cloudy',
  'Fog': 'foggy',
  'Light rain': 'rainy',
  'Rain': 'rainy',
  'Heavy rain': 'rainy',
  'Rain showers': 'rainy',
  'Drizzle': 'drizzle',
  'Light drizzle': 'drizzle',
  'Sleet': 'snowy',
  'Light sleet': 'snowy',
  'Snow': 'snowy',
  'Light snow': 'snowy',
  'Heavy snow': 'snowy',
  'Snow showers': 'snowy',
  'Hail': 'snowy',
  'Thunder': 'thunderstorm',
  'Thunderstorm': 'thunderstorm',
};
